'use strict';

const on = require('dom-helpers/events/on');
const fetch = require('../../../common/frontend/helpers/fetch-decorator')(
  window.fetch
);
const { getElementById } = require('../../../common/frontend/helpers/utils');

const {
  getRememberMeSelection,
  getNewsletterSelection,
} = require('./social-common');

const xthrow = e => {
  throw e;
};

const successHandler = res => {
  if (!res) {
    return;
  }
  const access_token = res.authResponse.accessToken;
  const signed_request = res.authResponse.signedRequest;
  const remember_me = getRememberMeSelection();
  const newsletter = getNewsletterSelection();
  const host = window.location.origin;
  const qs = window.location.search;
  const facebookURL = `${host}/facebook${qs}`;
  const terms_of_service_version = document.querySelector(
    'input[name="terms_of_service_version"]'
  ).value;
  const privacy_policy_version = document.querySelector(
    'input[name="privacy_policy_version"]'
  ).value;

  const body = new URLSearchParams({
    access_token,
    signed_request,
    remember_me,
    newsletter,
    terms_of_service_version,
    privacy_policy_version,
    accept_terms: true,
  }).toString();

  fetch(facebookURL, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    method: 'POST',
    body,
  })
    .then(response => (response.ok ? response.json() : xthrow(new Error())))
    .then(({ location }) => {
      if (window.location !== window.parent.location) {
        window.top.location.reload();
      } else {
        window.location.href = encodeURI(location);
      }
    })
    .catch(error => {
      window.Groupon.Utils.trackEvent('facebook-signin-xhr-failure', {
        error: JSON.stringify(error),
      });
    });
};

const login = (rerequest = false) => {
  const renderReAuthModal = () => {
    const modal_header = window.I18n.t(
      'js.modules.facebook.rerequest_modal_header'
    );
    const modal_body = window.I18n.t(
      'js.modules.facebook.rerequest_modal_body'
    );
    const modal_button_text = window.I18n.t(
      'js.modules.facebook.rerequest_modal_button'
    );
    const no_thanks = window.I18n.t('js.modules.facebook.rerequest_no_thanks');
    const modal_template = `<div class="modal" aria-hidden="true" aria-labelledby="triggerId" aria-modal="false" id="facebook_reauth_modal">
       <div class="modal-body">
         <h2 class="modal-title section-title text-center">
           ${modal_header}
         </h2>
         <div class="row text-center">
           <p>${modal_body}</p>
         </div>
         <div class="row text-center">
           <button class="btn" id="fb-reauth-submit">${modal_button_text}</button>
           <div class="row">
            <a href="#" class="close-modal">${no_thanks}</a>
           </div>
         </div>
       </div>
      </div>`;

    window.GIG.Modal.create(modal_template);

    on(getElementById('fb-reauth-submit'), 'click', e => {
      e.stopPropagation();
      login(true);
    });
  };

  window.FB.login(
    response => {
      if (response.authResponse) {
        if (!response.authResponse.grantedScopes.includes('email')) {
          renderReAuthModal();
        } else {
          successHandler(response);
        }
      } else {
        window.Groupon.Utils.trackEvent(
          'facebook-signin-authentication-failure',
          { error: response }
        );
      }
    },
    {
      scope: 'public_profile,email',
      return_scopes: true,
      auth_type: rerequest ? 'rerequest' : '',
    }
  );
};

module.exports = () => {
  const { socialConfig } = window.Groupon.Utils.getConfigFromDom();
  const { appId, enabled } = socialConfig.facebook;
  const version = 'v3.0';

  if (!enabled) {
    return;
  }

  window.fbAsyncInit = function() {
    window.FB.init({
      appId,
      status: true, // Determines the user's status is freshly retrieved. According to the comments in groupon social, not turning this on prevents the user's status from being properly returned when checkLoginStatus is called.
      cookie: false, // Enables of disables a cookie being generated for the users authentication session. This is turned off because saving our signed request with an unsecure is not a good idea. In fairness, this is taken from a comment on groupon social, so I am unsure as to how valid this concern is now.
      xfbml: true, // Determines wether eXtended FaceBook Markup Language (XFBML) tags are enabled. This makes it easier for facebook sdk to identify what resources are used on the page and load in the correct plugins.
      version,
    });
  }.bind(this);

  (function(d, s, id) {
    const fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) return;
    const js = d.createElement(s);
    js.id = id;
    js.async = true;
    js.src = `https://connect.facebook.net/${window.I18n.locale}/sdk.js#xfbml=1&version=${version}&appId=${appId}&autoLogAppEvents=1`;
    fjs.parentNode.insertBefore(js, fjs);
  })(document, 'script', 'facebook-jssdk');

  on(getElementById('facebook-button'), 'click', () => login(false));
};
